import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Newspaper } from "lucide-react";
import { api, fullUrl } from "../lib/api";
import { usePageKeywords } from "../lib/seo";
import { LogoBadge } from "../components/site/LogoBadge";

export default function BlogPage() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    usePageKeywords("blog");

    useEffect(() => {
        document.title = "مدونة شركة إطار الثريا لخدمات السيارات | نصائح وأدلة الإطارات";
        api.get("/posts")
            .then((r) => setPosts(r.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="min-h-screen bg-[#0A1228] grain-overlay" data-testid="blog-page">
            <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0A1228]/85 border-b border-white/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
                    <LogoBadge />
                    <Link
                        to="/"
                        data-testid="blog-back-home"
                        className="flex items-center gap-2 text-sm font-bold text-slate-300 border border-white/15 rounded-full px-5 py-2.5 hover:border-amber-400/50 hover:text-amber-400 transition-colors duration-300"
                    >
                        <ArrowRight className="w-4 h-4" />
                        العودة للرئيسية
                    </Link>
                </div>
            </header>

            <main className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
                <p className="font-mono-spec text-xs tracking-[0.3em] text-amber-400 mb-3" dir="ltr">
                    BLOG
                </p>
                <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-white mb-3">
                    مدونة شركة إطار الثريا لخدمات السيارات
                </h1>
                <p className="text-slate-400 text-base mb-12 max-w-2xl">
                    نصائح العناية بالإطارات، أدلة الاختيار، وأخبار الماركات العالمية.
                </p>

                {loading ? (
                    <p className="text-slate-500 text-sm">جاري التحميل...</p>
                ) : posts.length === 0 ? (
                    <div className="text-center py-24 text-slate-500" data-testid="blog-empty">
                        <Newspaper className="w-10 h-10 mx-auto mb-4 text-slate-700" />
                        قريباً — مقالات قيد الإعداد
                    </div>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                        {posts.map((p) => (
                            <Link
                                key={p.id}
                                to={`/blog/${p.slug}`}
                                data-testid={`blog-list-card-${p.slug}`}
                                className="group spotlight-card border border-white/10 rounded-3xl overflow-hidden hover:border-amber-400/40 transition-colors duration-500 flex flex-col"
                            >
                                {p.image && (
                                    <div className="relative h-48 overflow-hidden">
                                        <img
                                            src={fullUrl(p.image)}
                                            alt={p.title}
                                            loading="lazy"
                                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                        />
                                        <span className="absolute bottom-2.5 left-2.5 bg-white/95 rounded-lg px-1.5 py-0.5 shadow-lg">
                                            <img src="/assets/brand/mero-logo.jpg" alt="Mero" className="h-5 w-auto object-contain" />
                                        </span>
                                    </div>
                                )}
                                <div className="p-6">
                                    {p.category && (
                                        <span className="text-[10px] font-bold text-amber-400 bg-amber-400/10 border border-amber-400/25 rounded-full px-3 py-1">
                                            {p.category}
                                        </span>
                                    )}
                                    <h2 className="font-display font-bold text-white text-lg leading-snug mt-3">
                                        {p.title}
                                    </h2>
                                    <p className="text-sm text-slate-400 leading-relaxed line-clamp-3 mt-2">
                                        {p.excerpt}
                                    </p>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </main>
        </div>
    );
}
